<template>
  <div>
    <div class="d-flex flex-column align-items-center mb-4">
      <div class="padded-content d-flex flex-column justify-content-center align-items-center">
        <strong v-if="showTitle" class="title mb-2">
          {{ i18n.t('components.image_upload.add_image_title') }}
        </strong>

        <div v-if="showDescription" class="text-center">
          {{ description }}
        </div>
      </div>
    </div>

    <div class="stock-image-search">
      <search-stock-image-form @search-image="(v) => $emit('search-image', v)" />
    </div>
    <div class="upload-file mt-5">
      <strong class="title">
        {{ i18n.t('components.image_upload.upload_your_own') }}
      </strong>
      <p v-html="i18n.t('components.image_upload.upload_hint_html')" />
      <primary-button class="col-md-6 col-12" :label="i18n.t('administrative.upload_image')" @click="$emit('upload-file')" />
    </div>
  </div>
</template>

<script>
import isPresent from '@/helpers/is-present'
import PrimaryButton from '@/components/buttons/primary-button'
import SearchStockImageForm from './search-stock-image-form'

export default {
  components: { PrimaryButton, SearchStockImageForm },

  props: {
    description: {
      type: String,
      required: false
    },

    showTitle: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  emits: ['search-image', 'upload-file'],

  computed: {
    showDescription() {
      return isPresent(this.description)
    }
  }
}
</script>
